import axios from "../config/axios-mcp";

export const MCPServersRepository = {
    getAll: (projectId) => {
        return axios.get(`/servers/${projectId}`);
    },
    reloadServer: (id) => {
        return axios.get(`/servers/${id}/reload`);
    },
    delete: (id) => {
        return axios.delete(`/servers/${id}`)
    },
    create: (data) => {
        return axios.post('/servers', data)
    },
    edit: (id, data) => {
        return axios.put(`/servers/${id}`, data)
    },
    getTools:(data)=>{
        return axios.post(`/mcp/tools`,data);
    },
    callTool:(data)=>{
        return axios.post(`/mcp/call`,data);
    },
    getPrompts:(data)=>{
        return axios.post(`/mcp/prompts`,data);
    }
}